// extracted by mini-css-extract-plugin
module.exports = {"midterm-date-button":"CalendarModal_midterm-date-button__5eJiM","calendare-header-container":"CalendarModal_calendare-header-container__JJS6O"};